module.exports = __webpack_public_path__ + "img/05.6b4fd2df.jpg";